import { render, staticRenderFns } from "./TileItem.vue?vue&type=template&id=83ba650c&scoped=true"
import script from "./TileItem.vue?vue&type=script&lang=js"
export * from "./TileItem.vue?vue&type=script&lang=js"
import style0 from "./TileItem.vue?vue&type=style&index=0&id=83ba650c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ba650c",
  null
  
)

export default component.exports